import { API_URL } from '../../../app-config/constants';
import SlackConfigurationState from '../../../types/SlackConfigurationState';
import { get, remove } from '../request';

const BASE_URL = `${API_URL}/slack-configurations`;

removeErrors.operation = 'DELETE';
export function removeErrors(): Promise<void> {
    return remove(`${BASE_URL}/errors`);
}

getConfiguration.operation = 'READ';
getConfiguration.idFrom = 'ARGS';
export function getConfiguration(): Promise<SlackConfigurationState> {
    return get(`${BASE_URL}`);
}
